import axios from 'axios';

export const fetchAddressByCep = async (cep) => {
  const cleanCep = cep.replace(/[^\d]/g, '');

  if (cleanCep.length !== 8) return null;

  try {
    const { data } = await axios.get(`https://viacep.com.br/ws/${cleanCep}/json/`);

    if (data.erro) return { error: true, message: 'CEP não encontrado' };

    return {
      zip_code: cleanCep,
      street: data.logradouro || '',
      district: data.bairro || '',
      city: data.localidade || '',
      state: data.uf || '',
      error: false,
    };
  } catch (err) {
    return { error: true, message: 'Erro na consulta do CEP' };
  }
};
